import { NonNullableStringParameter, useAssignQueryParameter } from '@pba/react-router';
import { useMemo } from 'react';

export const useCommunityInvitationTokenParams = () => {
  const { value: invitationToken } = useAssignQueryParameter('invitation_token', NonNullableStringParameter);

  return useMemo(
    () => ({
      invitationToken,
    }),
    [invitationToken],
  );
};
